// 계정 삭제 안내 페이지 (비로그인 접근) — Google Play 필수 항목
//
// Play는 계정 생성이 가능한 앱에 대해 "앱 내 삭제 경로"와 별개로
// "웹에서 접근 가능한 삭제 요청 경로"를 요구한다. 앱을 지운 뒤에도 삭제를 요청할 수
// 있어야 하므로 이 페이지는 로그인 없이 열려야 하고, 스토어 등록 정보에 URL로 제출한다.
import React from "react";
import { Link } from "react-router-dom";

const Section: React.FC<{ title: string; children: React.ReactNode }> = ({ title, children }) => (
  <section className="mb-8">
    <h2 className="mb-3 text-base font-bold text-slate-800">{title}</h2>
    <div className="space-y-2 text-sm leading-relaxed text-slate-600">{children}</div>
  </section>
);

export default function AccountDeletionPage() {
  return (
    <div className="min-h-screen bg-slate-50">
      <div className="border-b border-slate-200 bg-white">
        <div className="mx-auto max-w-3xl px-4 py-6">
          <Link to="/" className="mb-4 inline-flex items-center gap-1.5 text-sm text-slate-500 hover:text-slate-700">
            ← 홈으로
          </Link>
          <h1 className="text-2xl font-extrabold text-slate-900">계정 삭제 안내</h1>
          <p className="mt-1 text-sm text-slate-500">지기(JiGi) 앱 · 계정 및 데이터 삭제 요청</p>
        </div>
      </div>

      <div className="mx-auto max-w-3xl px-4 py-8">
        <Section title="앱에서 직접 탈퇴하기">
          <p>앱에 로그인한 뒤 아래 경로에서 직접 탈퇴할 수 있습니다.</p>
          <p className="rounded-xl bg-white p-3 font-medium text-slate-700 ring-1 ring-slate-200">
            마이페이지 → 회원 탈퇴 → 비밀번호 확인
          </p>
        </Section>

        <Section title="앱을 삭제했거나 로그인할 수 없는 경우">
          <p>
            아래 연락처로 <strong>가입한 아이디 또는 등록된 전화번호</strong>를 알려주시면
            본인 확인 후 삭제를 처리해 드립니다.
          </p>
          <p className="rounded-xl bg-white p-3 text-slate-700 ring-1 ring-slate-200">
            새로운 연구소 (학원 운영시간 중 접수)
          </p>
        </Section>

        <Section title="삭제되는 정보">
          <ul className="list-disc space-y-1 pl-5">
            <li>계정 정보 — 아이디, 이름, 연락처, 이메일, 비밀번호</li>
            <li>알림 발송을 위해 저장된 기기 정보(푸시 토큰)</li>
          </ul>
          <p>
            탈퇴를 요청하시면 <strong>즉시 로그인이 차단</strong>되고, 잘못 요청한 경우를 대비해
            <strong> 30일이 지난 뒤 위 정보가 파기</strong>됩니다. 30일 안에 학원으로 문의하시면
            되돌릴 수 있습니다.
          </p>
        </Section>

        <Section title="삭제되지 않고 보관되는 정보">
          <p>
            아래 정보는 계정과 별개로 학원이 보관하는 기록이거나 법령상 보존 의무가 있어
            탈퇴 후에도 남습니다.
          </p>
          <ul className="list-disc space-y-1 pl-5">
            <li>
              <strong>원생 학습 기록</strong>(리포트·출결·학습 이력) — 학원이 수강 계약과
              별도 동의에 따라 보관하는 운영 기록입니다. 이 기록의 삭제를 원하시면
              학원으로 문의해 주세요.
            </li>
            <li>
              <strong>결제·환불 기록</strong> — 전자상거래 등에서의 소비자보호에 관한 법률에 따라
              5년간 보존합니다.
            </li>
          </ul>
        </Section>

        <Section title="교사·원장 계정">
          <p>
            교사·원장 계정은 앱에서 직접 탈퇴할 수 없습니다. 학원 관리자에게 문의해 주세요.
          </p>
        </Section>

        <p className="text-xs text-slate-400">
          자세한 개인정보 처리 기준은 <Link to="/privacy" className="underline">개인정보처리방침</Link>을
          참고해 주세요.
        </p>
      </div>
    </div>
  );
}
